import React from 'react';
import CustomInput from 'components/custom-input/custom-input.component';
import { InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FormError from 'components/form-error/form-error.component';
import TrimTextField from './trim-text-field/trim-text-field.component';
import { ErrorMessage } from '@hookform/error-message';
import { useResetDefaultValue } from './useResetDefaultValue';

const LastName = ({ errors, register, defaultValue, disabled }) => {
  const { t } = useTranslation();

  useResetDefaultValue('lastName', defaultValue);

  return (
    <CustomInput>
      <InputLabel htmlFor="lastName">{t('forms.label.lastName')}*</InputLabel>
      <TrimTextField
        id="lastName"
        fullWidth
        placeholder={t('forms.placeholder.lastName')}
        error={!!errors.lastName}
        inputProps={{ autoComplete: 'family-name', 'aria-required': true }}
        {...register('lastName', {
          validate: {
            required: value =>
              !value?.trim() ? t('register.errors.requiredField') : true,
            emoji: value =>
              /\p{Extended_Pictographic}/u.test(value)
                ? t('errors.emojis')
                : true,
          },
        })}
        defaultValue={defaultValue}
        disabled={disabled}
      />
      <ErrorMessage
        errors={errors}
        name="lastName"
        render={({ message }) => (
          <FormError errorMessage={message} data-testid="LastName.FormError" />
        )}
      />
    </CustomInput>
  );
};

export default LastName;
